// extracted by mini-css-extract-plugin
module.exports = {"googleButton":"GoogleLogin_googleButton__q01sk"};